import { ViewName } from "./ViewConstants";
/**
 * The entity type of the destination view.
 * Short values used here to keep the url short
 */ export var SubRouteType = /*#__PURE__*/ function(SubRouteType) {
    /** Basic plan view */ SubRouteType["BasicPlan"] = "plan";
    /** Portfolio view */ SubRouteType["Portfolio"] = "portfolio";
    /** Premium plan (Project) view */ SubRouteType["PremiumPlan"] = "premiumplan";
    /** Legacy list (Todo) view */ SubRouteType["TodoList"] = "list";
    /** My day view */ SubRouteType["MyDay"] = "myday";
    /** My tasks view */ SubRouteType["MyTasks"] = "mytasks";
    /** Collections hub */ SubRouteType["MyPlans"] = "myplans";
    /** My portfolios view */ SubRouteType["MyPortfolios"] = "myportfolios";
    /** Task publishing */ SubRouteType["Publishing"] = "publishing";
    /** Message task */ SubRouteType["MessageTasks"] = "messagetasks";
    /** Create / edit teams tab */ SubRouteType["ConfigTeamsTab"] = "configteamstab";
    /** Remove teams tab */ SubRouteType["RemoveTeamsTab"] = "removeteamstab";
    /** New tab landing page view */ SubRouteType["NewTabPage"] = "newtabpage";
    return SubRouteType;
}({});
/**
 * SubRoute component keys
 */ export var SubRouteKeys = /*#__PURE__*/ function(SubRouteKeys) {
    /** SubRoute View - Value after is ViewType*/ SubRouteKeys["View"] = "view";
    /** SubRoute Task - Value after is TaskId*/ SubRouteKeys["Task"] = "task";
    /** SubRoute Org - Value after is OrgId */ SubRouteKeys["Org"] = "org";
    /** SubRoute Dialog - Value after is ModalType */ SubRouteKeys["Dialog"] = "dialog";
    /** SubRoute Template type - Value after is template type */ SubRouteKeys["TemplateType"] = "templatetype";
    /** SubRoute Plan type - Value after is plan type */ SubRouteKeys["PlanType"] = "plantype";
    return SubRouteKeys;
}({});
/**
 * Query parameter component keys
 */ export var QueryParameterKeys = /*#__PURE__*/ function(QueryParameterKeys) {
    /** Modal */ QueryParameterKeys["Modal"] = "modal";
    /** Template type for create plan modal */ QueryParameterKeys["TemplateType"] = "templatetype";
    /** Switch to query string parameter when page is redirected from planner service */ QueryParameterKeys["SwitchTo"] = "switchTo";
    return QueryParameterKeys;
}({});
/**
 * Query string values for the SwitchTo parameter when uno is loaded from planner service.
 */ export var PlannerServiceSwitchToValues = /*#__PURE__*/ function(PlannerServiceSwitchToValues) {
    /** Switch to Uno tab */ PlannerServiceSwitchToValues["Uno"] = "uno";
    return PlannerServiceSwitchToValues;
}({});
/**
 * View types
 */ export var ViewType = /*#__PURE__*/ function(ViewType) {
    ViewType["Grid"] = "grid";
    ViewType["Board"] = "board";
    ViewType["List"] = "list";
    ViewType["Charts"] = "charts";
    ViewType["Schedule"] = "schedule";
    ViewType["Timeline"] = "timeline";
    ViewType["People"] = "people";
    ViewType["Goals"] = "goals";
    ViewType["Assignments"] = "assignments";
    ViewType["CopilotHome"] = "copilothome";
    ViewType["Report"] = "report";
    return ViewType;
}({});
// Key for TryPremium button
export const TryPremiumTabKey = "try-premium";
/**
 * Portfolio View types
 */ export var PortfolioViewType = /*#__PURE__*/ function(PortfolioViewType) {
    PortfolioViewType["Roadmap"] = "roadmap";
    PortfolioViewType["Plans"] = "plans";
    return PortfolioViewType;
}({});
/**
 * The prefix for legacy Task List subRoutes
 */ export const legacyTaskListTypePrefix = [
    "personalApp",
    "alltasklists",
    "taskListType"
];
/**
 * Routes that currently support undo/redo tracking. Today: BasicPlan only.
 * Extend this set as undo support rolls out to additional views (MyTasks, MyDay, Portfolio, etc.).
 */ export const UndoSupportedRoutes = new Set([
    "plan"
]);
/**
 * Evo - Mapping of primary views that render on each subRouteType
 */ export const PlannerSubRouteTypeToViewNameMap = {
    ["plan"]: ViewName.PlanPage,
    ["premiumplan"]: ViewName.PremiumPlanPage,
    ["list"]: ViewName.PlanPage,
    ["myday"]: ViewName.MyDayPage,
    ["mytasks"]: ViewName.MyTasksPage,
    ["myplans"]: ViewName.MyPlansPage,
    ["myportfolios"]: ViewName.MyPortfoliosPage,
    ["publishing"]: ViewName.PublishingPage,
    ["messagetasks"]: ViewName.CreateTaskPage,
    ["configteamstab"]: ViewName.ConfigTeamsTabPage,
    ["removeteamstab"]: ViewName.RemoveTeamsTabPage,
    ["newtabpage"]: ViewName.NewTabPage,
    ["portfolio"]: ViewName.PortfolioPage
};
/**
 * Uno - Mapping of primary views that render on each subRouteType
 */ export const SubRouteTypeToViewNameMap = {
    ["plan"]: ViewName.BasicPlanPage,
    ["premiumplan"]: ViewName.PremiumPlanPage,
    ["list"]: ViewName.BasicPlanPage,
    ["myday"]: ViewName.MyDayPage,
    ["mytasks"]: ViewName.MyTasksPage,
    ["myplans"]: ViewName.MyPlansPage,
    ["myportfolios"]: ViewName.MyPortfoliosPage,
    ["publishing"]: ViewName.PublishingPage,
    ["messagetasks"]: ViewName.CreateTaskPage,
    ["configteamstab"]: ViewName.ConfigTeamsTabPage,
    ["removeteamstab"]: ViewName.RemoveTeamsTabPage,
    ["newtabpage"]: ViewName.NewTabPage,
    ["portfolio"]: ViewName.PortfolioPage
};
export const DefaultViewTypeForPersonalViews = "board";
